import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { faWarning, faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { ReportService } from 'src/app/services/report.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { faFile } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-view-analysis-summary',
  templateUrl: './view-analysis-summary.component.html',
  styleUrls: ['./view-analysis-summary.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})


export class ViewAnalysisSummaryComponent implements OnInit, AfterViewInit {

  @Output() loaded = new EventEmitter();

  faWarning = faWarning;
  faFile = faFile as IconProp;
  faExternalLink = faExternalLink;
  matriximg: any;

  simple = input(false);
  report = input.required<any>();
  forPDF = input.required<boolean>();

  constructor(
    public dialog: MatDialog,
    public readonly reportService: ReportService,
    public readonly toast: ConfirmationToastComponent,
  ) {

  }

  ngOnInit(): void {
    this.getBase64ImageFromURL("/assets/img/matrix.png").then((value: any) => {
      this.matriximg = value;
    })
    return
  }

  getBase64ImageFromURL(url: string) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx!.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(new Error("img load failed"));
      };

      img.src = url;
    });
  }

  ngAfterViewInit(): void {
    this.loaded.emit(4);
  }

  customATOB(s: string): string {
    try {
      return atob(s)
    } catch (err) {
      if (err) {
        return s
      }
    }
    return s
  }

  decodeURI(url: string): string {
    return decodeURI(url)
  }
}
